import { memo } from 'react';
import { Menu } from '@wg/wows-react-uikit';

import { getSeasonTeams } from '~/helpers/seasons';
import { TEAMS_NAMES } from '~/helpers/teams';

import styles from './LadderTeamsDropdown.scss';

import type { ITeamStatistics } from '~/types/declaration';

interface LadderTeamsDropdownProps {
  statistics: ITeamStatistics;
  season: number;
  selectedTeamNumber: number;
  onTeamNumberChange: (teamNumber: number) => void;
}

const LadderTeamsDropdown = (props: LadderTeamsDropdownProps) => {
  const { statistics, season, selectedTeamNumber, onTeamNumberChange } = props;

  const ratings = statistics.ratings;
  if (!ratings) {
    return null;
  }

  const seasonTeams = getSeasonTeams(ratings, season);
  if (seasonTeams.length < 2) {
    return null;
  }

  const teamsMap = seasonTeams
    .map((team) => ({
      value: team.team_number,
      content: TEAMS_NAMES[team.team_number],
    }))
    .sort((teamA, teamB) => teamA.value - teamB.value);

  const currentTeamNumber = selectedTeamNumber || statistics.leadingTeamNumber || teamsMap[0]?.value;

  return (
    <div className={styles.container}>
      <Menu
        items={teamsMap}
        itemSelected={currentTeamNumber}
        onItemChange={(val: number) => {
          onTeamNumberChange(val);
        }}
      >
        <div className={styles.label}>{TEAMS_NAMES[currentTeamNumber]}</div>
      </Menu>
    </div>
  );
};

export default memo(LadderTeamsDropdown);
